<template>
    <div class="filter-bar">

        <div class="filter-bar--select">
            <vs-select
                ref="filterSelected"
                class="selectExample"
                v-model="select1"
            >
                <vs-select-item
                    :is-selected.sync="item.isSelected"
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="item,index in options1" />
            </vs-select>
        </div>
        <!--<select class="filter-bar--select" name="view-users">
            <option value="">Tutti</option>
            <option value="">Posizione</option>
            <option value="">Responsabile</option>
            <option value="">Matricola</option>
        </select>-->
        <input type="text" v-model="filterText" @keyup="doFilter" :placeholder="[[ __('misc.search') ]]">
        <button class="btn btn--only-icon" @click="doFilter"><i class="fal fa-search"></i></button>
        <!--<button class="btn btn--only-icon" @click="resetFilter"><i class="fas fa-times"></i></button>-->
    </div>
</template>

<script>
    export default {
        data () {
            return {
              eventPrefix: 'vuetable-filterBar:',
              filterText: '',
              select1:'all',
              options1:[
                  {value: 'all', label: 'All', isSelected: false },
                  {value: 'roles', label: 'Job', isSelected: false },
                  {value: 'fullname', label: 'Person', isSelected: false },
                  {value: 'Valutatore', label: 'Evaluator', isSelected: false },
                  {value: 'status', label: 'Status', isSelected: false },

              ],}
        },
        methods: {
            doFilter () {
                this.$emit(this.eventPrefix+'doFilter', this.filterText);
            },
            resetFilter () {
                this.filterText = "";
                this.$emit(this.eventPrefix+'resetFilter', this.filterText);
            }
        }
    }
</script>
